// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"n7","cardInnerHeading":"n8","toggleWrapperClass":"n9","changeProfile":"n- n9","textWrapperClass":"n_","toggleTextClass":"oa"};